export default function checkUniqueFactory({
  attributeName,
  entityList,
  entityName,
  id,
  idAttributeName,
}) {
  if (!entityList || !Array.isArray(entityList)) {
    throw new Error(
      `checkUniqueFactory requires a ${entityName} entityList to check against`
    );
  }
  return function checkUnique(value) {
    // Must have a value to conflict
    if (!value) {
      return true;
    }

    const config = {
      attributeName,
      id,
      idAttributeName,
      value: normalize(value),
    };
    const conflict = entityList.find(testEntity =>
      hasConflict(testEntity, config)
    );

    // Return if no conflict is found
    if (!conflict) {
      return true;
    }

    return `Another ${entityName} has the same value. Please enter a unique value.`;
  };
}

function hasConflict(testEntity, config) {
  const { value, id, attributeName, idAttributeName } = config;

  let testId = testEntity[idAttributeName];

  // Skip self
  if (id === testId) {
    return false;
  }

  let testValue = testEntity[attributeName];

  // Must have a value to conflict
  if (!testValue) {
    return false;
  }

  testValue = normalize(testValue);

  return testValue === value;
}

function normalize(value) {
  return value.trim().toLowerCase();
}
